import { connect } from 'react-redux'
import { GameInfoCard } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { settings: userSettings } = state.settings
  const { language } = state.user
  var messages

  return ({
    width,
    userSettings,
    messages,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameInfoCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/GameInfoCard.js